export const JOB_LEVEL_BACKFILL_MODAL_UI_SELECTOR = "job-level-backfill-modal";

export const JOB_LEVEL_BACKFILL_MODAL_ACTIVE_BODY_ATTRIBUTE =
  "data-job-level-backfill-active";
